/* ==========================================================================
   AURA — PRODUCT PAGE (Phase 1)
   AURA-only UX. Variant switching + AJAX add-to-cart stay in Dawn's
   product-info.js / product-form.js. This script handles:
     · revealing the desktop sticky add-to-cart bar once the main button
       scrolls out of view (mobile uses a CSS-fixed buy bar instead)
     · mirroring the live price into the sticky bar on variant change
     · a lightweight localStorage wishlist toggle
   ========================================================================== */
(function () {
  'use strict';

  function initStickyBar(pdp) {
    const section = pdp.dataset.section;
    const sticky = pdp.querySelector('.aura-pdp__sticky');
    const submit = pdp.querySelector('#ProductSubmitButton-' + section);
    if (!sticky || !submit) return;

    // Reveal the bar the moment the real add-to-cart button slides up behind the
    // (sticky) header — i.e. its bottom edge passes the header's bottom edge.
    const headerEl =
      document.querySelector('.section-header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('header');

    const headerBottom = () =>
      headerEl ? Math.max(0, headerEl.getBoundingClientRect().bottom) : 0;

    let ticking = false;
    const update = () => {
      const rect = submit.getBoundingClientRect();
      const behindHeader = rect.bottom <= headerBottom() + 4;
      sticky.classList.toggle('is-visible', behindHeader);
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { update(); ticking = false; });
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update, { passive: true });

    // Keep the sticky price in sync with the live (variant-updated) price node.
    const livePrice = pdp.querySelector('#price-' + section);
    const stickyPrice = pdp.querySelector('#price-sticky-' + section);
    if (livePrice && stickyPrice) {
      const sync = () => { stickyPrice.innerHTML = livePrice.innerHTML; };
      new MutationObserver(sync).observe(livePrice, { childList: true, subtree: true });
    }
  }

  /* ---------- Wishlist (localStorage) ---------- */

  const WISHLIST_KEY = 'aura:wishlist';

  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(ids) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
    } catch (e) {
      /* storage unavailable — wishlist is best-effort */
    }
  }

  function initWishlist(pdp) {
    const wrap = pdp.querySelector('aura-wishlist');
    if (!wrap) return;
    const btn = wrap.querySelector('.aura-pdp__wishlist-btn');
    const id = wrap.dataset.productId;
    if (!btn || !id) return;

    const reflect = () => {
      const active = readWishlist().indexOf(id) !== -1;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    };
    reflect();

    btn.addEventListener('click', () => {
      const ids = readWishlist();
      const i = ids.indexOf(id);
      if (i === -1) {
        ids.push(id);
      } else {
        ids.splice(i, 1);
      }
      writeWishlist(ids);
      reflect();
    });
  }

  function init() {
    document.querySelectorAll('.aura-pdp').forEach((pdp) => {
      initStickyBar(pdp);
      initWishlist(pdp);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
